import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, HardHat, FileCheck } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center pt-20 pb-32 overflow-hidden" data-id="element-230">
      {/* Background Image with Refined Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-231">
        <img src="https://cdn.magicpatterns.com/uploads/fk2oSBtYAssQfqfBQVaHEc/bluesky1.png" alt="Blue Sky Contractors at work" className="w-full h-full object-cover object-center scale-105 animate-[pulse_20s_ease-in-out_infinite_alternate]" data-id="element-232" />
        <div className="absolute inset-0 bg-navy/60 mix-blend-multiply" data-id="element-233"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/40 to-transparent" data-id="element-234"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full mt-10" data-id="element-235">
        <div className="max-w-4xl mx-auto text-center" data-id="element-236">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-237">
            <div className="flex items-center justify-center gap-4 mb-8" data-id="element-238">
              <div className="h-px w-8 bg-gold/50" data-id="element-239"></div>
              <span className="inline-block text-gold text-xs font-bold tracking-[0.2em] uppercase" data-id="element-240">
                Pennsylvania's Premier Contractor
              </span>
              <div className="h-px w-8 bg-gold/50" data-id="element-241"></div>
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-[1.1] mb-8" data-id="element-242">
              Your Home. <br className="hidden md:block" data-id="element-243" />
              <span className="text-gold italic" data-id="element-244">Your Pride.</span>{' '}
              <br className="hidden md:block" data-id="element-245" />
              Your Legacy.
            </h1>

            <p className="text-lg md:text-xl text-gray-300 mb-12 font-light max-w-2xl mx-auto leading-relaxed" data-id="element-246">
              The Pennsylvania Contractor That Turns Your Vision Into Reality —{' '}
              <span className="font-medium text-white border-b border-brand pb-0.5" data-id="element-247">
                Guaranteed
              </span>
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-16" data-id="element-248">
              <a href="#contact" className="relative overflow-hidden group w-full sm:w-auto bg-gold text-navy font-bold text-sm px-10 py-4 rounded-sm transition-all shadow-[0_0_20px_rgba(201,168,76,0.3)] hover:shadow-[0_0_30px_rgba(201,168,76,0.5)] uppercase tracking-widest" data-id="element-249">
                <span className="relative z-10" data-id="element-250">Get Free Estimate</span>
                <div className="absolute inset-0 h-full w-full bg-white/30 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out" data-id="element-251"></div>
              </a>
              <a href="#services" className="w-full sm:w-auto bg-transparent border border-white/30 hover:border-white hover:bg-white/5 text-white font-bold text-sm px-10 py-4 rounded-sm transition-all uppercase tracking-widest backdrop-blur-sm" data-id="element-252">
                Our Services
              </a>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Refined Floating Credentials Bar */}
      <div className="absolute bottom-0 left-0 w-full bg-navy/80 backdrop-blur-xl border-t border-white/10 py-8 z-20" data-id="element-253">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-254">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center divide-y md:divide-y-0 md:divide-x divide-white/10" data-id="element-255">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} className="flex items-center justify-center gap-4 pt-4 md:pt-0" data-id="element-256">
              <div className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center border border-white/10" data-id="element-257">
                <FileCheck className="text-brand w-5 h-5" data-id="element-258" />
              </div>
              <div className="text-left" data-id="element-259">
                <p className="text-white font-bold uppercase tracking-widest text-xs mb-1" data-id="element-260">
                  PA Licensed
                </p>
                <p className="text-gray-400 text-xs font-medium" data-id="element-261">#934782</p>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.5
          }} className="flex items-center justify-center gap-4 pt-4 md:pt-0" data-id="element-262">
              <div className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center border border-white/10" data-id="element-263">
                <HardHat className="text-gold w-5 h-5" data-id="element-264" />
              </div>
              <div className="text-left" data-id="element-265">
                <p className="text-white font-bold uppercase tracking-widest text-xs mb-1" data-id="element-266">
                  OSHA Certified
                </p>
                <p className="text-gray-400 text-xs font-medium" data-id="element-267">
                  #14-602163933
                </p>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.6
          }} className="flex items-center justify-center gap-4 pt-4 md:pt-0" data-id="element-268">
              <div className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center border border-white/10" data-id="element-269">
                <ShieldCheck className="text-brand w-5 h-5" data-id="element-270" />
              </div>
              <div className="text-left" data-id="element-271">
                <p className="text-white font-bold uppercase tracking-widest text-xs mb-1" data-id="element-272">
                  Fully Insured
                </p>
                <p className="text-gray-400 text-xs font-medium" data-id="element-273">
                  Zero Risk Guarantee
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}